/**
 * Prefix protocol-less external URLs with https://.
 * Leaves absolute paths, hashes, query strings, and URLs that already have a
 * scheme (http:, mailto:, etc.) unchanged.
 */
export const ensureHttpsProtocol = (href: string): string => {
  const trimmed = href.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (
    /^[a-z][a-z0-9+.-]*:/i.test(trimmed) ||
    trimmed.startsWith("/") ||
    trimmed.startsWith("#") ||
    trimmed.startsWith("?")
  ) {
    return trimmed;
  }
  return `https://${trimmed}`;
};
